module.exports = __webpack_public_path__ + "images/Fitness-1298c8c8d320c6c67e825af9f9e9e1bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos_icons/Fitness.svg
// module id = 769
// module chunks = 0